module.exports = __webpack_public_path__ + "static/media/dolby-atmos-flat.f058f1fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/dolby-atmos-flat.svg
// module id = 635
// module chunks = 0